// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"M1-z"};